import "./Header.scss";
import Button from "./Button";
import Logo from "../../assets/images/logo.png";

export default function Header() {
	return (
		<div className="header">
			<div className="decoration header-light-1"></div>
			
			<div className="header-content content-wrapper-lg">
				<div className="header-left"></div>

				<div className="header-center">
					<img className="header-logo" src={Logo} alt="logo" />
				</div>

				<div className="header-right">
					<Button className="launch-app-btn">
						DApp
					</Button>
				</div>
			</div>
		</div>
	);
}
